import { DeleteButton, EditButton, SaveButton, SimpleForm, Toolbar, TopToolbar, useNotify, useRecordContext, useRedirect} from 'react-admin';
import LinkToQbButton from '../contracts/LinkToQbButton';
import ClientCreateFuneralButton from './ClientDialogButtons/ClientCreateFuneralButton';
import {
  EditInDialogButton,
} from "@react-admin/ra-form-layout";
import ClientEditBase from './ClientEditBase';
import { ClientSaveButton } from './ClientSaveButton';
import { ClientSaveToolbar } from './ClientSaveToolbar';

const ClientShowToolBar = () => {
  
  return (
    <TopToolbar>
        <EditInDialogButton fullWidth maxWidth='md'>
          <SimpleForm toolbar={<ClientSaveToolbar />}>
            <ClientEditBase />
          </SimpleForm>
        </EditInDialogButton>
        {/* Add your custom actions */}
        <ClientCreateFuneralButton />
        <LinkToQbButton label="View in QB" type='customerdetail'/>
    </TopToolbar>
  );
};

export default ClientShowToolBar;
